import { Injectable } from '@angular/core';

export interface HttpErrorBreadcrumb {
  url: string;
  status: number;
  statusText?: string;
  timestamp: string;
}

@Injectable({ providedIn: 'root' })
export class ErrorBreadcrumbsService {
  private readonly maxBreadcrumbs = 5;
  private readonly breadcrumbs: HttpErrorBreadcrumb[] = [];

  recordHttpError(url: string, status: number, statusText?: string): void {
    if (!url) return;
    this.breadcrumbs.push({
      url,
      status,
      statusText: statusText || undefined,
      timestamp: new Date().toISOString(),
    });

    if (this.breadcrumbs.length > this.maxBreadcrumbs) {
      this.breadcrumbs.shift();
    }
  }

  getRecentErrors(): readonly HttpErrorBreadcrumb[] {
    return [...this.breadcrumbs];
  }

  clear(): void {
    this.breadcrumbs.length = 0;
  }
}
